export default "/credits/business/assets/952bec2b7ca191d2db8286f89a52c9f4.png";